import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ReactHTMLClass;
function ReactHTML() {
  if (ReactHTMLClass === VOID) {
    class $ {}
    initMetadataForObject($, 'ReactHTML');
    ReactHTMLClass = $;
  }
  return ReactHTMLClass;
}
var ReactHTML_instance;
function ReactHTML_getInstance() {
  return ReactHTML_instance;
}
//region block: init
ReactHTML_instance = new (ReactHTML())();
//endregion
//region block: exports
export {
  ReactHTML_instance as ReactHTML_instanced0ci4wsv0lrw,
};
//endregion

//# sourceMappingURL=ReactHTML.mjs.map
